import { selectById, selectSlice } from './pluginsEntitiesSlice';
import { hasActiveFlag } from './pluginsService';
import type { PluginProductCode } from './types';

/**
 * Only to be used in legacy non-react code.
 *  @deprecated use usePlugin hook instead.
 */
export function isPluginActive(id: PluginProductCode): boolean {
    const plugin = selectById(id);
    return !!plugin && hasActiveFlag(plugin);
}

/**
 * Only to be used in legacy non-react code.
 *  @deprecated use usePlugins hook instead.
 */
export function isPluginSliceAvailable(): boolean {
    const slice = selectSlice();
    return !!slice && !slice.isPending;
}
